export const COMMENTS = 'comments'
export const COMPONENTS = 'components'
export const GENERAL = 'general'
export const LOGIN_BUTTON = 'loginButton'
export const LOGIN_FORM = 'loginForm'
export const PATHS = 'paths'
export const POLICY_BANNER = 'policyBanner'
export const REGISTER_FORM = 'registerForm'
export const SOCIAL = 'social'
export const COLUMN_MODAL_MODULE = 'columnModalModule'
